/**
 * HTTP Headers Constants
 *
 * Centralized constants for HTTP headers used across the application
 * to avoid magic strings and ensure consistency.
 */
export const HTTP_HEADERS = {
  /**
   * Authorization header for Bearer token authentication
   */
  AUTHORIZATION: 'Authorization',
  /**
   * QIMA User ID header for API requests
   * Used to identify the authenticated user making the request
   */
  AI_USER_ID: 'Ai-User-Id',
  /**
   * QIMA User Role header for API requests
   * Used to identify the selected role of the authenticated user
   */
  AI_USER_ROLE: 'Ai-User-Role',
  /**
   * QIMA API Access Token header for API requests
   * Used for API authentication
   */
  AI_API_ACCESS_TOKEN: 'ai-api-access-token',
  /**
   * Content-Type header for API requests
   * Specifies the media type of the request body
   */
  CONTENT_TYPE: 'Content-Type',
  /**
   * Accept header for API requests
   * Specifies the media types that are acceptable for the response
   */
  ACCEPT: 'Accept',
} as const;

/**
 * Type for HTTP header keys
 */
export type HttpHeaderKey = (typeof HTTP_HEADERS)[keyof typeof HTTP_HEADERS];
